import client from '../../shared/api/client';
import { HotWallet, PaginatedResponse } from '../../shared/types';

interface BackendResponse<T> {
  success?: boolean;
  status?: string;
  data: T;
}

export interface HotWalletFilters {
  page?: number;
  per_page?: number;
  currency?: string;
  network?: string;
  address?: string;
  is_active?: boolean | string;
}

export interface HotWalletCreateInput {
  currency: string;
  network: string;
  address: string;
  private_key: string;
  label?: string | null;
  is_active?: boolean;
}

export interface HotWalletUpdateInput {
  label?: string | null;
  is_active?: boolean;
  private_key?: string;
}

export const listHotWallets = async (
  filters: HotWalletFilters = {}
): Promise<PaginatedResponse<HotWallet>> => {
  const params: Record<string, string | number | boolean | undefined> = {
    page: filters.page ?? 1,
    per_page: filters.per_page ?? 20,
  };
  if (filters.currency) params.currency = filters.currency;
  if (filters.network) params.network = filters.network;
  if (filters.address) params.address = filters.address;
  if (filters.is_active !== undefined && filters.is_active !== '') {
    params.is_active = filters.is_active;
  }

  const response = await client.get<BackendResponse<PaginatedResponse<HotWallet>>>(
    '/hot-wallets',
    { params }
  );
  return response.data.data;
};

export const getHotWallet = async (id: number): Promise<HotWallet> => {
  const response = await client.get<BackendResponse<HotWallet>>(`/hot-wallets/${id}`);
  return response.data.data;
};

export const createHotWallet = async (input: HotWalletCreateInput): Promise<HotWallet> => {
  const response = await client.post<BackendResponse<HotWallet>>('/hot-wallets', input);
  return response.data.data;
};

export const updateHotWallet = async (
  id: number,
  input: HotWalletUpdateInput
): Promise<HotWallet> => {
  const response = await client.put<BackendResponse<HotWallet>>(
    `/hot-wallets/${id}`,
    input
  );
  return response.data.data;
};

export const deleteHotWallet = async (id: number): Promise<void> => {
  await client.delete(`/hot-wallets/${id}`);
};
